/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { connect } from "react-redux";
import {
  AddToItemAction,
  RemoveFromCartAction,
  RemoveFromItemAction,
} from "../../Reducers/AddToCartReducer";
import { Add, Remove } from "@mui/icons-material";
import "./CheckoutProduct.css";

function CheckoutProduct({
  id,
  title,
  price,
  image,
  rating,
  quantity,
  removeFromCart,
  removeFromItem,
  addToItem,
  hideButton = false,
}) {
  return (
    <div className="checkoutProduct" key={id}>
      <img
        src={image}
        alt={`product image ${title}`}
        className="checkoutProduct__image"
      />
      <div className="checkoutProduct__info">
        <p className="checkoutProduct__title">{title}</p>
        <div className="checkoutProduct__details">
          <p className="checkoutProduct__price">
            <small>$</small>
            <strong>{price}</strong>
          </p>
          <div className="checkoutProduct__quantity">
            {!hideButton && (
              <Remove
                onClick={() => removeFromItem(id)}
                className="checkoutProduct__removeButton"
              />
            )}
            {hideButton && <strong>Quantity: </strong>}
            {quantity}
            {!hideButton && (
              <Add
                onClick={() => addToItem(id)}
                className="checkoutProduct__addButton"
              />
            )}
          </div>
          <div className="checkoutProduct__rating">
            {/* new learning */}
            {Array(rating)
              .fill()
              .map((_) => (
                <p>⭐</p>
              ))}
          </div>
        </div>
        {!hideButton && (
          <button onClick={() => removeFromCart(id)}>Remove from Cart</button>
        )}
      </div>
    </div>
  );
}

export default connect(null, {
  removeFromCart: RemoveFromCartAction,
  removeFromItem: RemoveFromItemAction,
  addToItem: AddToItemAction,
})(CheckoutProduct);
